export default __webpack_public_path__ + "static/media/report-blue.2a62f237.svg";